import ScrollMixin from '@/mixins/Scroll.js'
import SizesMixin from '@/mixins/Sizes.js'
import TimeMixin from '@/mixins/Time.js'

export default
{
    name: 'app-parallax',

    mixins:
    [
        ScrollMixin,
        SizesMixin,
        TimeMixin
    ],

    props:
    {
        parallaxAmount: { type: Number, default: 18 }, // value in percent +10% of its height to -10%
        onlyPositive: { type: Boolean, default: false }
    },

    created()
    {
        this.bounds = {
            top: 0,
            bottom: 0,
            height: 0,
            width: 0
        }
        this.isVisible = false
        this.isEnabled = true
        this.elemHeight = 0
        this.parallaxAmountPx = 0
        this.roundedValue = 0

        if(this.$root.config.platform.touch)
        {
            this.isEnabled = false
        }
    },

    mounted()
    {
        if(this.isEnabled)
        {
            this.calculateBounds()
            this.initParallax()

            this.$refs.inner.style.transform = `scale(1.${this.parallaxAmount})`

            this.updateVisibility()
        }
    },

    methods:
    {
        onScroll()
        {
            if(this.isEnabled)
            {
                this.updateVisibility()
            }
        },

        onResize()
        {
            if(this.isEnabled)
            {
                this.calculateBounds()
                this.updateVisibility()

                if(!this.isVisible)
                {
                    this.initParallax()
                }
            }
        },

        onTick()
        {
            if(this.isVisible && this.isEnabled)
            {
                this.applyParallax()
            }
        },

        calculateBounds()
        {
            const bounding = this.$el.getBoundingClientRect()
            const scrollY = window.scrollY

            this.bounds = {
                top: bounding.top + scrollY,
                bottom: bounding.bottom + scrollY,
                height: bounding.height,
                width: bounding.width
            }
        },

        updateVisibility()
        {
            this.isVisible = this.scroll.current > this.bounds.top - this.sizes.height && this.scroll.current < this.bounds.bottom
        },

        initParallax()
        {
            this.parallaxAmountPx = this.bounds.height / 100 * this.parallaxAmount

            if(!this.onlyPositive)
            {
                this.$el.style.transform = `translateY(${-this.parallaxAmountPx}px)`
            }
        },

        applyParallax()
        {
            const currentProgress = this.scroll.current - (this.bounds.top - this.sizes.height)
            const maxProgress = this.bounds.height + this.sizes.height
            const normalizedProgress = currentProgress / maxProgress
            const roundedValue = Math.round((-this.parallaxAmountPx + (this.parallaxAmountPx + this.parallaxAmountPx) * normalizedProgress) * 10) / 10

            if(roundedValue !== this.roundedValue)
            {
                this.$el.style.transform = `translateY(${roundedValue}px)`
                this.roundedValue = roundedValue
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-parallax/script.js